import React from 'react';

export function TwoLinesColumnFormatter(cellContent) {

  return (
    <div>
      <div className="text-dark-75 font-weight-bolder d-block font-size-lg">
        {cellContent.agentName}
      </div>
      <div className="text-dark-75 font-weight-bolder d-block font-size-lg">
        {cellContent.agentID}
      </div>
    </div>
  );
}
